/**
 * Mojo Up AI Cloud: what a view says to an organisation without Teams (cloudPlan.ts). A person's own space is an
 * account, and a free team keeps what it has until it moves to Teams, so the view names what Teams brings and offers
 * the one way there instead of a workspace whose every change would be refused.
 */

import { Persons } from '@gravity-ui/icons';

import { useCloudStanding } from '../cloudPlan.ts';
import { UpgradeToTeamsCard } from '../components/cloud/UpgradeToTeams.tsx';
import { Page, PageHeader } from '../components/ui.tsx';

export function TeamsOnlyPage() {
  const { personal } = useCloudStanding();
  return (
    <Page narrow>
      <PageHeader tone="blue" icon={<Persons />} title="Part of Teams" subtitle={personal ? 'Projects, policies, the catalogue, memory and remote control are for teams.' : 'This team is on the free plan, so this is read-only for now.'} />
      <UpgradeToTeamsCard tone="blue" />
    </Page>
  );
}

/** A view that needs Teams on Cloud: the view itself when the organisation has it (and always on Enterprise). */
export function TeamsOnly({ children }: { children: React.ReactNode }) {
  const { teams } = useCloudStanding();
  return teams ? <>{children}</> : <TeamsOnlyPage />;
}
